import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';

class DefaultAccountAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'DefaultAccounts';
}
export default new DefaultAccountAPI();
